export const POST_USER_TYPE = 'POST_USER_TYPE'
export const POST_USER_TYPE_REQUEST = 'POST_USER_TYPE_REQUEST'
export const POST_USER_TYPE_SUCCESS = 'POST_USER_TYPE_SUCCESS'
export const POST_USER_TYPE_FAILURE = 'POST_USER_TYPE_FAILURE'

export const postUserTypeRequest = (requestBody) => ({ type: POST_USER_TYPE_REQUEST, payload: { data: requestBody } })
export const postUserTypeSuccess = (data) => {
  return ({ type: POST_USER_TYPE_SUCCESS, data })
}


export const POST_UPDATE_USER = 'POST_UPDATE_USER'
export const POST_UPDATE_USER_REQUEST = 'POST_UPDATE_USER_REQUEST'
export const POST_UPDATE_USER_SUCCESS = 'POST_UPDATE_USER_SUCCESS'
export const POST_UPDATE_USER_FAILURE = 'POST_UPDATE_USER_FAILURE'

export const postUpdateUserRequest = (requestBody) => ({ type: POST_UPDATE_USER_REQUEST, payload: { data: requestBody } })
export const postUpdateUserSuccess = (data) => {
  return ({ type: POST_UPDATE_USER_SUCCESS, data })
}

export const PATCH_USER_PROFILE = 'PATCH_USER_PROFILE'
export const PATCH_USER_PROFILE_REQUEST = 'PATCH_USER_PROFILE_REQUEST'
export const PATCH_USER_PROFILE_SUCCESS = 'PATCH_USER_PROFILE_SUCCESS'
export const PATCH_USER_PROFILE_FAILURE = 'PATCH_USER_PROFILE_FAILURE'

export const patchUserProfileRequest = (requestBody) => ({ type: PATCH_USER_PROFILE_REQUEST, payload: { data: requestBody } })
export const patchUserProfileSuccess = (data) => {
  return ({ type: PATCH_USER_PROFILE_SUCCESS, data })
}

export const GET_FREE_CREDIT_REQUEST = 'GET_FREE_CREDIT_REQUEST'
export const GET_FREE_CREDIT_SUCCESS = 'GET_FREE_CREDIT_SUCCESS'
export const GET_FREE_CREDIT_FAILURE = 'GET_FREE_CREDIT_FAILURE'

export const getFreeAICreditRequest = () => ({ type: GET_FREE_CREDIT_REQUEST})

export const PATCH_USER_REQUEST = 'PATCH_USER_REQUEST'
export const PATCH_USER_SUCCESS = 'PATCH_USER_SUCCESS'
export const PATCH_USER_FAILURE = 'PATCH_USER_FAILURE'

export const patchUserRequest = (requestBody) => ({ type: PATCH_USER_REQUEST, payload: { data: requestBody } })
export const patchUserSuccess = (data) => {
  return ({ type: PATCH_USER_SUCCESS, data }) 
}
